import { proxy } from "valtio";
import { AddPositionAsset } from "@/src/features/api/memberApi";

/**
 * MenuSearchModal 勾选状态极简存储
 * - 与收藏状态解耦，仅维护勾选的资产 id 集合
 */
export const menuSearchSelection = proxy<{
  /** 勾选的资产 id 集合（与资产类型无关） */
  selectIds: AddPositionAsset[];
  updateIds: (asset: AddPositionAsset, checked?: boolean) => void;
  clear: () => void;
}>({
  selectIds: [],
  updateIds: (asset: AddPositionAsset, checked?: boolean) => {
    if (!asset?.asset_id) {
      return;
    }

    const existsIndex = menuSearchSelection.selectIds.findIndex(
      (item) => item.asset_id === asset.asset_id,
    );
    const exists = existsIndex !== -1;
    const shouldCheck = typeof checked === "boolean" ? checked : !exists;

    if (shouldCheck && !exists) {
      menuSearchSelection.selectIds.push(asset);
    } else if (!shouldCheck && exists) {
      menuSearchSelection.selectIds.splice(existsIndex, 1);
    }
  },
  clear: () => {
    menuSearchSelection.selectIds = [];
  },
});
